import React from 'react';
import './TodosLoading.css';

function TodosLoading() {
  return (
    <>
     <div className='loading-bar'>Loading</div>
    </>
  );
}

export { TodosLoading };